export default __webpack_public_path__ + "static/media/heart-success.f5381e9e.svg";